import React, { FC, memo } from 'react';
import { DivBreak, DivSubheader, SpanArrow } from './styles';
import StepButton from '../StepButton/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

type TProps = {
  activeStep: number;
  onChangeStep: (index: number) => void;
};

const Subheader: FC<TProps> = ({ activeStep, onChangeStep }) => (
  <>
    <DivBreak />
    <DivSubheader>
      <StepButton
        index={0}
        text="Set configuration"
        onClick={(index) => onChangeStep(index)}
        isActive={activeStep === 0}
      />
      <SpanArrow>
        <FontAwesomeIcon icon={faChevronRight} size="1x" />
      </SpanArrow>
      <StepButton
        index={1}
        text="Set implementation"
        onClick={(index) => onChangeStep(index)}
        isActive={activeStep === 1}
      />
    </DivSubheader>
  </>
);

export default memo(Subheader);
